import { ModalWindow } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TechProblems } from '../../components/TechProblems';
import { modalClose } from '../../actions/modal';
import { TITLE } from './constants';
import { selectModalState } from '../../selectors/modal';

export const TechProblemsModalContainer: React.FC = () => {
  const dispatch = useDispatch();
  const { open } = useSelector(selectModalState);

  const handleCloseModal = React.useCallback(() => {
    dispatch(modalClose());
  }, []);

  return (
    <ModalWindow
      fixed
      open={open}
      onClose={handleCloseModal}
      title={TITLE}
      width="100%"
      maxWidth={540}
      content={<TechProblems />}
      escape={false}
      size="M"
    />
  );
};
